import React, { createContext, useEffect, useMemo, useState } from 'react'
import { Icons } from '../utils/icons.jsx'

const ThemeContext = createContext()

const themeOptions = [
    { value: 'light', icon: Icons.default.LightMode, label: 'light' },
    { value: 'dark', icon: Icons.default.DarkMode, label: 'dark' },
    { value: 'system', icon: Icons.default.SystemTheme, label: 'system' },
]

const ThemeContextProvider = ( { children } ) => {

    const [theme, setTheme] = useState( 'light' )
    const [selectedTheme, setSelectedTheme] = useState( localStorage.getItem( 'preferedTheme' ) || 'light' )


    useEffect( () => {
        if ( selectedTheme === 'system' ) {
            if ( window.matchMedia && window.matchMedia( '(prefers-color-scheme: dark)' ).matches ) {
                document.body.classList.add( 'dark' )
                setTheme( 'dark' )
            } else if ( window.matchMedia && window.matchMedia( '(prefers-color-scheme: light)' ).matches ) {
                setTheme( 'light' )
                document.body.classList.remove( 'dark' )
            } else {
                setTheme( 'light' )
                document.body.classList.remove( 'dark' )
            }
        } else
            setTheme( selectedTheme )
    }, [selectedTheme] )

    return <ThemeContext.Provider value={{ themeOptions, theme, setTheme, selectedTheme, setSelectedTheme }}>
        {children}
    </ThemeContext.Provider>
}

/* Hook to use store in any functional component */
export const useThemeContext = () => React.useContext( ThemeContext )

export default ThemeContextProvider